import * as React from 'react'

type CssWrapperProps = {
  className?: string
  children: React.ReactNode
}

export const CSSWrapper = ({
  className,
  children
}: CssWrapperProps): React.ReactElement<unknown> =>
  className ? (
    <div className={className}>{children}</div>
  ) : (
    // children could be multiple elements/components,
    // so we need a fragment here.
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>{children}</>
  )

CSSWrapper.displayName = 'CSSWrapper'
